import { gql } from '@apollo/client';

export const CHECK_ORDER_FOR_RELABEL = gql`
    query CheckOrderForRelabel($neutralTrackingNumber: String!) {
        checkOrderForRelabel(neutralTrackingNumber: $neutralTrackingNumber) {
            orderId
            trackingNumber
            externalTrackingNumber
            isTemuUsps
            needsRelabel
            recipientName
            recipientAddressLine
            recipientCityLine
        }
    }
`;

export interface RelabelCheckResult {
    orderId: number;
    trackingNumber?: string;
    externalTrackingNumber?: string;
    isTemuUsps: boolean;
    needsRelabel: boolean;
    recipientName?: string;
    recipientAddressLine?: string;
    recipientCityLine?: string;
}

export interface CheckOrderForRelabelResponse {
    checkOrderForRelabel: RelabelCheckResult | null;
}
